import React, { createContext, useContext, useState, ReactNode, Dispatch, SetStateAction } from 'react';
import { initValue, initialSelectedCheckboxes, initPdfIntroData } from '../CalendarProps/CalendarProps';
import { TransformedEvent } from "./ParsingUtil";
import { PdfIntroTypes } from "./pdf/fetchPdfIntoduction";

interface GlobalContextProps {
  appointments: TransformedEvent[];
  setAppoitments: Dispatch<SetStateAction<TransformedEvent[]>>;
  checkBoxOutlook: string[];
  setCheckBoxOutlook: Dispatch<SetStateAction<string[]>>;
  checkBoxAppointment: string[];
  setCheckBoxAppointment: Dispatch<SetStateAction<string[]>>;
  filteredAppointmnets: TransformedEvent[];
  setFilteredAppointmnets: Dispatch<SetStateAction<TransformedEvent[]>>;
  pdfIntroData: PdfIntroTypes;
  setPdfIntroData: Dispatch<SetStateAction<PdfIntroTypes>>;
}

interface CheckboxStateProviderProps {
  children: ReactNode;
}

const GlobalContext = createContext<GlobalContextProps | undefined>(undefined);

export const GlobalContextProvider: React.FunctionComponent<
  CheckboxStateProviderProps
> = ({ children }) => {
  const [appointments, setAppoitments] = useState<TransformedEvent[]>([
    initValue,
  ]);
  const [checkBoxOutlook, setCheckBoxOutlook] = useState<string[]>(
    initialSelectedCheckboxes
  );
  const [checkBoxAppointment, setCheckBoxAppointment] = useState<string[]>(
    initialSelectedCheckboxes
  );
  
  const [filteredAppointmnets, setFilteredAppointmnets] = useState<
    TransformedEvent[]
  >([initValue]);
  const [pdfIntroData, setPdfIntroData] = useState<PdfIntroTypes>(
    initPdfIntroData
  );

  return (
    <GlobalContext.Provider
      value={{
        appointments,
        setAppoitments,
        checkBoxOutlook,
        setCheckBoxOutlook,
        filteredAppointmnets,
        setFilteredAppointmnets,
        checkBoxAppointment,
        setCheckBoxAppointment,
        pdfIntroData, 
        setPdfIntroData
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useCallbackState = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error('useCheckboxState must be used within a CheckboxStateProvider');
  }
  return context;
};